import * as React from "react";
import { defaultValues, toSelectOptions } from "../../../services/defaults";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const Datadog: React.FC<Props> = ({ index }) => {
  const df = defaultValues.org.logging.datadog;

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.datadog.host`}>Host</CpLabel>
          <CpSelect
            options={toSelectOptions(df.host.options)}
            name={`logging.${index}.datadog.host`}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.datadog.host`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.datadog.credentials`}>Credentials</CpLabel>
          <CpDescription>Select an Opaque secret to access Datadog</CpDescription>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "opaque" }]}
            name={`logging.${index}.datadog.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.datadog.credentials`} />
        </CpFormItem>
      </div>
    </>
  );
};
